import React, { useState, useContext, useEffect } from "react";
import {
  Grid,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Divider,
  Dialog,
  DialogTitle,
} from "@material-ui/core";
import { getDateFromWeekAndDay } from "../../GlobalFunctions";
import ButtonCreate from "../ButtonCreate";
import { LinehaulFixedDataContext } from "../../Contexts/LinehaulFixedDataContext";
import UploadFileSection from "../UploadFileSection";
import ButtonUpload from "../ButtonUpload";

const CreateLinehaulFixed = (props) => {
  const { truckId, week, day, ...otherProps } = props;
  const {
    linehaulFixedModel,
    fixedColumns,
    defaultFixed,
    getActiveRoutesObj,
    routesObj,
    comments,
  } = useContext(LinehaulFixedDataContext);
  // const routesObj = getActiveRoutesObj(truckId, week);
  const [files, setFiles] = useState([]);
  const displayColumns = [...fixedColumns, comments];

  const [formData, setFormData] = useState({
    values: displayColumns.reduce((acc, cur) => ({ ...acc, [cur]: "" }), {}),
    valid: {},
  });

  const handleChange = (event) => {
    const newFormData = {
      ...formData,
      values: {
        ...formData.values,
        [event.target.name]: event.target.value,
      },
    };
    if (event.target.name === "routeId" || event.target.name === "adjustment") {
      newFormData.values.tripCost = Number(
        routesObj[newFormData.values.routeId].routeRate
      );
      newFormData.values.totalCost =
        newFormData.values.tripCost + Number(newFormData.values.adjustment);
    }
    setFormData(newFormData);
  };

  useEffect(() => {
    setFormData({
      ...formData,
      valid: {
        ...Object.keys(formData.values).reduce(
          (acc, cur) => ({
            ...acc,
            [cur]: linehaulFixedModel[cur].validate(formData.values),
          }),
          {}
        ),
      },
    });
  }, [formData.values]);

  return (
    <Dialog open={true} {...otherProps} fullWidth maxWidth="sm">
      <DialogTitle>Add New Fixed Linehaul</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText component="span">
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="center"
            spacing={1}
          >
            {["routeId"].map((col) => (
              <React.Fragment key={col}>
                <Grid item xs={3}>
                  {linehaulFixedModel[col].displayName}
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={formData.values[col]}
                    onChange={handleChange}
                    error={!formData.valid[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...linehaulFixedModel[col].textFieldProps}
                    children={linehaulFixedModel[col].getChildren(
                      truckId,
                      week
                    )}
                  />
                </Grid>
              </React.Fragment>
            ))}
            {["adjustment"].map((col) => (
              <React.Fragment key={col}>
                <Grid item xs={3}>
                  {linehaulFixedModel[col].displayName}
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={formData.values[col]}
                    onChange={handleChange}
                    error={!formData.valid[col]}
                    disabled={!formData.valid.routeId}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...linehaulFixedModel[col].textFieldProps}
                  />
                </Grid>
              </React.Fragment>
            ))}
            {["tripCost", "totalCost", comments].map((col) => (
              <React.Fragment key={col}>
                <Grid item xs={3}>
                  {linehaulFixedModel[col].displayName}
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    value={formData.values[col]}
                    onChange={handleChange}
                    error={!formData.valid[col]}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...linehaulFixedModel[col].textFieldProps}
                  />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
        </DialogContentText>
      </DialogContent>
      <UploadFileSection files={files} setFiles={setFiles} />
      <DialogActions>
        <ButtonUpload
          // disabled={loading}
          color="primary"
          variant="contained"
          maxFileSize={10000000}
          accept={[".png", ".jpg", ".pdf", ".docx", ".xlsx", ".csv"]}
          multiple={false}
          files={files}
          setFiles={setFiles}
        >
          Browse
        </ButtonUpload>
        <ButtonCreate
          disabled={Object.values(formData.valid).includes(false)}
          variant="contained"
          color="primary"
          controller="linehauls"
          truckId={truckId}
          week={week}
          day={day}
          itemData={{
            ...defaultFixed,
            ...formData.values,
            routeId: Number(formData.values.routeId),
            adjustment: Number(formData.values.adjustment),
            driverId: truckId,
            eventDateTime: getDateFromWeekAndDay(week, day).dateIsoString,
          }}
          files={files}
          callback={props.onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CreateLinehaulFixed;
